import Axios, { InternalAxiosRequestConfig } from 'axios';

import { IoTCoreAdminSystemInfo } from '@/config';
import storage from '@/utils/storage';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = storage.getToken();
  // Both read per request rather than at module scope: this module is evaluated on
  // import, which happens before the sidecar config fetch resolves.
  config.baseURL = IoTCoreAdminSystemInfo.URL;
  config.headers['ClearBlade-SystemKey'] = IoTCoreAdminSystemInfo.systemKey;

  if (token) {
    config.headers['ClearBlade-UserToken'] = token;
  }

  config.headers.Accept = 'application/json';
  return config;
}

export const axiosAdminUserAccount = Axios.create();
axiosAdminUserAccount.interceptors.request.use(authRequestInterceptor);
